module.exports = __webpack_public_path__ + "img/level_one_hover.8a8b654e.png";